import React from 'react';
import PropTypes from 'prop-types';
import { BeatportIcon } from '../customIcons/BeatportIcon';
import { SoundCloudIcon } from '../customIcons/SoundCloudIcon';
import { SpotifyIcon } from '../customIcons/SpotifyIcon';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Stack, Link, styled } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import IosShareIcon from '@mui/icons-material/IosShare';
import { useSnackbar } from 'notistack';
import copyToClipboard from '../utils/copyToClipboard';

const SocialLink = styled(Link)(({ theme }) => ({
  width: '50px',
  height: '50px',
  //background: theme.palette.common.black,
  color: theme.palette.common.white,
  textAlign: 'center',
  borderRadius: '4px',
  fontSize: '28px',
  border: '1px solid',

  svg: {
    marginTop: theme.spacing(1),
    verticalAlign: 'middle',
  },
}));

const SocialLinks = ({ data, type = 'artist' }) => {
  const {
    id,
    name,
    beatport,
    //soundcloud,
    //spotify,
    //facebook,
    instagram,
    //twitter,
    youtube,
    website,
  } = data;

  const { enqueueSnackbar } = useSnackbar();

  async function copyEntity() {
    // Note: Artist/Label sharing doesn't use share tracking yet
    // This can be extended in the future if needed
    const entityLink = `https://api.kip.audio/public/preview/${
      type === 'label' ? 'labels' : 'artists'
    }/${id}`;
    const message = `Check out ${name} on KIP: `;
    copyToClipboard(message, entityLink, name, enqueueSnackbar);
  }

  // Always show the share button, so hasSocial is not used to conditionally render the component
  // Remove the check for hasSocial

  return (
    <Stack direction="row" spacing={2}>
      {/* Share button */}
      <SocialLink
        component="button"
        type="button"
        onClick={copyEntity}
        sx={{
          background: 'none',
          borderRadius: '4px',
          border: '1px solid',
          padding: 0,
          minWidth: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '50px', // match SocialLink height
          width: '50px', // match SocialLink width
          '& svg': {
            marginTop: 0, // reset if needed
            fontSize: 28, // match other icons
          },
        }}
      >
        <IosShareIcon />
      </SocialLink>
      {beatport && (
        <SocialLink
          component="a"
          href={beatport}
          target="_blank"
          rel="noreferrer"
        >
          <BeatportIcon />
        </SocialLink>
      )}
      {/*soundcloud && (
        <SocialLink
          component="a"
          href={soundcloud}
          target="_blank"
          rel="noreferrer"
        >
          <SoundCloudIcon />
        </SocialLink>
      )}}
      {spotify && (
        <SocialLink
          component="a"
          href={spotify}
          target="_blank"
          rel="noreferrer"
        >
          <SpotifyIcon />
        </SocialLink>
      )}
      {facebook && (
        <SocialLink
          component="a"
          href={facebook}
          target="_blank"
          rel="noreferrer"
        >
          <FacebookIcon />
        </SocialLink>
      )*/}
      {instagram && (
        <SocialLink
          component="a"
          href={instagram}
          target="_blank"
          rel="noreferrer"
        >
          <InstagramIcon />
        </SocialLink>
      )}
      {/*twitter && (
        <SocialLink
          component="a"
          href={twitter}
          target="_blank"
          rel="noreferrer"
        >
          <TwitterIcon />
        </SocialLink>
      )*/}
      {youtube && (
        <SocialLink
          component="a"
          href={youtube}
          target="_blank"
          rel="noreferrer"
        >
          <YouTubeIcon />
        </SocialLink>
      )}
      {website && (
        <SocialLink
          component="a"
          href={`http://${website}`}
          to={{ pathname: `http://${website}` }}
          target="_blank"
          rel="noreferrer"
        >
          <LanguageIcon />
        </SocialLink>
      )}
    </Stack>
  );
};

SocialLinks.propTypes = {
  data: PropTypes.object,
};

export default SocialLinks;
